import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Início", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Seções", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_fab, {
      slot: "fixed",
      vertical: "bottom",
      horizontal: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_fab_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate(_ctx.data.inicial==false?'/carrinho':'/mercado'))),
          color: _ctx.data.inicial==false?'jauservevermelho':'jauserveazulclaro',
          class: "footer-menu-buttom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_badge, {
              color: _ctx.data.inicial!=false?'jauservevermelho':'jauserveazulclaro'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.cartItemNumber), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_component_ion_icon, {
              icon: _ctx.data.inicial==false?_ctx.cart:_ctx.bag
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["color"]),
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate(_ctx.data.inicial==false?'/carrinho':'/mercado'))),
              size: "12",
              class: _normalizeClass(["ion-no-padding ion-text-center cart-total", _ctx.isAnimation!=0?'cart-total-animate':'cart-total-noanimate'])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$cart.currencyUSD(_ctx.cartTotal)), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.data.fab)
      ? (_openBlock(), _createBlock(_component_ion_footer, {
          key: 0,
          class: "ion-no-border"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, {
              color: "footertab",
              class: "ion-footer-menu ion-text-center ion-no-border"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      class: _normalizeClass(_ctx.$route.name=='Dashboard'?'ion-name-selected':'ion-name'),
                      size: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('/'))),
                          expand: "full",
                          fill: "clear"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.homeOutline }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _hoisted_1
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_ion_col, {
                      class: _normalizeClass(_ctx.$route.name=='Secoes'?'ion-name-selected':'ion-name'),
                      size: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('/secoes'))),
                          expand: "full",
                          fill: "clear"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.gridOutline }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_ion_col, {
                      class: "ion-no-padding ion-text-center",
                      size: "1"
                    }),
                    _createVNode(_component_ion_col, {
                      class: "ion-no-padding ion-text-center",
                      size: "2"
                    }),
                    _createVNode(_component_ion_col, {
                      class: "ion-no-padding ion-text-center",
                      size: "1"
                    }),
                    _createVNode(_component_ion_col, {
                      class: _normalizeClass(_ctx.$route.name=='Promocoes'?'ion-name-selected':'ion-name'),
                      size: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigate('/promocoes'))),
                          expand: "full",
                          fill: "clear"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { src: _ctx.descontoIcon }, null, 8, ["src"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.$route.name=='Promocoes'?'ion-name-selected':'ion-name')
                        }, "Promoções", 2)
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_ion_col, {
                      class: _normalizeClass(_ctx.$route.name=='Lojas'?'ion-name-selected':'ion-name'),
                      size: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigate('/lojas'))),
                          expand: "full",
                          fill: "clear"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.storefrontOutline
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.$route.name=='Lojas'?'ion-name-selected':'ion-name')
                        }, "Lojas", 2)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}